import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface AGBPageProps {
  onBack: () => void;
}
export function AGBPage({
  onBack
}: AGBPageProps) {
  return <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-423">
      <div className="max-w-3xl mx-auto" data-id="element-424">
        <button onClick={onBack} className="flex items-center text-slate-500 hover:text-brand-500 transition-colors mb-8 group" data-id="element-425">
          <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-426" />
          Zurück zur Startseite
        </button>

        <h1 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mb-8" data-id="element-427">
          Allgemeine Geschäftsbedingungen (AGB)
        </h1>

        <div className="prose prose-slate max-w-none text-slate-600" data-id="element-428">
          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-429">
            1. Geltungsbereich
          </h2>
          <p data-id="element-430">
            Für alle Bestellungen über unseren Online-Shop durch Verbraucher und
            Unternehmer gelten die nachfolgenden AGB.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-431">
            2. Vertragspartner, Vertragsschluss
          </h2>
          <p data-id="element-432">
            Der Kaufvertrag kommt zustande mit der Nuviora UG
            (haftungsbeschränkt.
          </p>
          <p data-id="element-433">
            Die Darstellung der Produkte im Online-Shop stellt kein rechtlich
            bindendes Angebot, sondern einen unverbindlichen Online-Katalog dar.
            Sie können unsere Produkte zunächst unverbindlich in den Warenkorb
            legen und Ihre Eingaben vor Absenden Ihrer verbindlichen Bestellung
            jederzeit korrigieren.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-434">
            3. Lieferbedingungen
          </h2>
          <p data-id="element-435">
            Zuzüglich zu den angegebenen Produktpreisen kommen noch
            Versandkosten hinzu. Näheres zur Höhe der Versandkosten erfahren Sie
            bei den Angeboten.
          </p>
          <p data-id="element-436">
            Wir liefern nur im Versandweg. Eine Selbstabholung der Ware ist
            leider nicht möglich.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-437">
            4. Bezahlung
          </h2>
          <p data-id="element-438">
            In unserem Shop stehen Ihnen grundsätzlich die folgenden
            Zahlungsarten zur Verfügung:
          </p>
          <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-439">
            <li data-id="element-440">Kreditkarte</li>
            <li data-id="element-441">PayPal</li>
            <li data-id="element-442">Sofortüberweisung</li>
            <li data-id="element-443">Rechnung (über Klarna)</li>
          </ul>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-444">
            5. Eigentumsvorbehalt
          </h2>
          <p data-id="element-445">Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum.</p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-446">
            6. Transportschäden
          </h2>
          <p data-id="element-447">
            Werden Waren mit offensichtlichen Transportschäden angeliefert, so
            reklamieren Sie solche Fehler bitte möglichst sofort beim Zusteller
            und nehmen Sie bitte unverzüglich Kontakt zu uns auf.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-448">
            7. Gewährleistung und Garantien
          </h2>
          <p data-id="element-449">
            Soweit nicht nachstehend ausdrücklich anders vereinbart, gilt das
            gesetzliche Mängelhaftungsrecht.
          </p>
          <p data-id="element-450">
            Zusätzlich gewähren wir eine 60-Tage-Geld-zurück-Garantie.
            Einzelheiten dazu finden Sie auf unserer Website unter "Garantie".
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8 mb-4" data-id="element-451">
            8. Streitbeilegung
          </h2>
          <p data-id="element-452">
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit, die Sie hier finden:
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-brand-500 hover:underline ml-1" data-id="element-453">
              https://ec.europa.eu/consumers/odr/
            </a>
            .
          </p>
        </div>
      </div>
    </div>;
}